// Model v3 模型解釋力資料欄位
export const MODEL_INTERPRET_FIELDS = [
    'model_name',
    'top_10_features',
    'credit_score',
]; 
